import React from "react";
import { PieChart, Pie, Tooltip, Cell } from "recharts";

const getRandomColor = () => {
  let n = (Math.random() * 0xfffff * 1000000).toString(16);
  return "#" + n.slice(0, 6);
};

const processData = (data, key = "service_name") => {
  const result = {};

  data.forEach((item) => {
    const keyName = item[key];
    if (result[keyName]) {
      result[keyName].value += 1;
    } else {
      result[keyName] = {
        name: keyName,
        value: 1,
        color: getRandomColor(),
      };
    }
  });

  return Object.keys(result).map((name) => result[name]);
};

const PieChartComponent = ({
  data,
  groupByKey = "service_name",
  colors = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"],
  width = 400,
  height = 400,
  outerRadius = 150,
  innerRadius = 0,
  dataKey = "value",
  showTooltip = true,
  showLabel = true,
}) => {
  const processedData = processData(data, groupByKey);

  return (
    <PieChart width={width} height={height}>
      <Pie
        data={processedData}
        cx={width / 2}
        cy={height / 2}
        outerRadius={outerRadius}
        innerRadius={innerRadius}
        fill="#8884d8"
        dataKey={dataKey}
        legendType="circle"
        paddingAngle={1}
        minAngle={1}
        label={
          showLabel
            ? ({ name, percent }) => `${name}: (${(percent * 100).toFixed(2)}%)`
            : null
        }
      >
        {processedData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry["color"]} />
        ))}
      </Pie>
      {showTooltip && <Tooltip formatter={(value) => `${value}`} />}
    </PieChart>
  );
};

export default PieChartComponent;
